module.exports = __webpack_public_path__ + "img/meter.6d7f92d1.png";